import { requestWithToken as request } from "./api";

export function getResultStateByPeriod(period, initDate, endDate) {
    console.log("API CALL: getResultStateByPeriod", { period, initDate, endDate });
    return request.get(
        `/financial_reports_view/get_result_state_by_period/?period=${period}&init_date=${initDate}&end_date=${endDate}`
    );
}

/**
 * Obtiene el acumulado mensual de ventas desagregado por cuenta level_3.
 * @param {string} initDate - Fecha inicio en formato YYYY-MM-DD
 * @param {string} endDate  - Fecha fin en formato YYYY-MM-DD
 * @param {string} groupBy  - Columna para agrupar ('cuentas', 'clientes' o nombre de categoría)
 */
export function getSalesByLevel3(initDate, endDate, groupBy = 'cuentas') {
    return request.get(
        `/financial_reports_view/get_sales_by_level3/?init_date=${initDate}&end_date=${endDate}&group_by=${groupBy}`
    );
}

// export function saveCartera(
//     company_id,
//     old_analists,
//     new_analists,
//     deleted_analists
// ) {
//     const param = {
//         old_analists: old_analists,
//         new_analists: new_analists,
//         deleted_analists: deleted_analists,
//     };
//     return request.post(`/analyst_view/${company_id}/save_cartera/`, param);
// }
